import React, { useState, useEffect } from 'react';
import style from './style.module.css';

import ChapterBlock from '../../parts/ChapterBlock/ChapterBlock';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';

import { chapterLabel } from '../../utils/helpers';

import { getUserChaptersData, getLanguageArray, Language, systemLanguage, academyLabel, academyIntroTextLabel, getLabel } from '../../utils/constants';

const Academy: React.FC = () => {

  const [sessionLang, setSessionLang] = useState<Language>(getLanguageArray());
  const [currentIndex, setCurrentIndex] = useState<number>(0);

  const chapters = getUserChaptersData();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const goNext = () => {
    if (currentIndex < chapters.length - 1) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  const goBack = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  const currentChapter = chapters?.[currentIndex];
  const moduleProgress = currentChapter?.modules
  ? currentChapter.modules.map((module) => ({
      status: module.status as 'complete' | 'in_progress' | 'unavailable',
      label: module.label?.[sessionLang.short] ?? '',
      link: module.link,
    }))
  : [];

  useEffect(() => {
        const handler = (e: StorageEvent) => {
          if (e.key === systemLanguage && e.newValue) {
            setSessionLang(JSON.parse(e.newValue));
          }
        };
        window.addEventListener("storage", handler);
        return () => window.removeEventListener("storage", handler);
    }, []);

  return (
    <div className={style.academyHome}>
      <div className={style.header}>
        <div className={`${style.greeting} ${style.textContainerGrad}`}>{getLabel(academyLabel,sessionLang)}</div>
        <div className={style.info}>{getLabel(academyIntroTextLabel,sessionLang)}</div>
      </div>
      <div className={style.carouselWrapper}>
        {currentChapter && (
          <>
            <div className={style.chapterContainer}>
              <ChapterBlock
                key={currentChapter.label}
                num={currentIndex}
                content={chapterLabel(currentChapter.chapter, sessionLang)} 
                statusIcon={currentChapter.status}
                progress={moduleProgress}
                totalNumber={currentChapter.modules.length}
                pagination={true}
                backButton={currentIndex > 0 ? (
                  <div className={style.chapterArrowLeft} onClick={goBack}>
                    <FontAwesomeIcon icon={faChevronLeft} />
                  </div>
                ) : null}
                forwardButton={currentIndex < chapters.length - 1  ? (
                  <div className={style.chapterArrowRight} onClick={goNext}>
                    <FontAwesomeIcon icon={faChevronRight} />
                  </div>
                ) : null}
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Academy;
